import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

export default function DeleteDialog({ open, cancelAction, confirmAction }) {
	return (
		<div>
			<Dialog
				open={open}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">
					{"Ви хочете видалити склад?"}
				</DialogTitle>
				<DialogContent></DialogContent>
				<DialogActions>
					<Button onClick={cancelAction}>Ні</Button>
					<Button onClick={confirmAction} autoFocus>
						Так
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
}
